function MSAssignmentReport2Logger() {
    /// <summary>
    /// This object provides js functions for the Widget.Membership.Assigment.* <br/>
    /// <br/>
    /// Author: MWI<br />
    /// Date: 11.04.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 11.5.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// * - includes special functions for handling the extra items          *<br />
    /// **********************************************************************<br />
    /// </summary>
  
}

MSAssignmentReport2Logger.prototype = new window.MSAssignment();

MSAssignmentReport2Logger.prototype.loadItems = function (id) {
    /// <summary>
    /// Overload of the parent fucntion to load the items
    /// </summary>
    var me = this;
    
    try {
        me.parameter = "";
        me.signalParameter = "";
    me.assID = -1;
    window.MSAssignment.prototype.loadItems.call(me, id);
    me.visual.find(".connect").off("dblclick", ".vc-list-item");

    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.loadItems', ex);
    }
};

MSAssignmentReport2Logger.prototype.initSortable = function() {
    var me = this;
    try {
          window.MSAssignment.prototype.initSortable.call(me);
             me.visual.find(".connect").off("dblclick", ".vc-list-item");

    } catch (ex) {
               me.writeError('MSAssignmentReport2Logger.initSortable', ex);

    }
};

MSAssignmentReport2Logger.prototype.addspecificClickHandler = function () {
    /// <summary>
    /// This function inits the assigment specific click handler if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    try {
        if (me.error) { return false; }
        //_VCMQ.addConsumer(me.vcgid);
        //_VCMQ.consume(me.visual, me.vcgid, function(event) {me.doEvent(event)});
        me.visual.find("#lstTarget").off("click").on("click", "  .vc-list-item", function (event) {me.clickRemoveArrow(event, this);});
        me.visual.find("#lstSource").off("click").on("click", " .vc-list-item", function (event) {me.clickAddArrow(event, this);});

    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.addspecificClickHandler', ex);
        return false;
    }
    return true;
};

MSAssignmentReport2Logger.prototype.clickAddArrow = function (event, element) {
    /// <summary>
    /// This handles the click of the add arrow button
    /// by changing the appearance and getting the update call
    /// </summary>
    var me = this;
    try {
        event.stopPropagation();
        //set the underlying hidden input and the classes
        if ($(element).hasClass("selected") === false) {
            me.visual.find("#lstSource .vc-list-item").removeClass("selected icon-color-ok");
            $(element).addClass("selected icon-color-ok");

        } else {
            $(element).removeClass("selected icon-color-ok");

        }
        me.checkExchangeValid();

    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.clickAddRemoveArrow', ex);

    }
    return true;
};
MSAssignmentReport2Logger.prototype.clickRemoveArrow = function(event, element) {
    /// <summary>
    /// This handles the click of the remove arrow button
    /// by changing the appearance and getting the update call
    /// </summary>
    var me = this;
    try {
        event.stopPropagation();
        //set the underlying hidden input and the classes
        if ($(element).hasClass("selected") === false) {
            me.visual.find("#lstTarget .vc-list-item").removeClass("selected icon-color-error");
            $(element).addClass("selected icon-color-error");

        } else {
            $(element).removeClass("selected icon-color-error");

        }
        me.checkExchangeValid();

    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.clickAddRemoveArrow', ex);

    }
    return true;
};
MSAssignmentReport2Logger.prototype.checkExchangeValid = function () {
    /// <summary>
    /// This handles the validation of the exchange buttons 
    /// by changing the appearance and getting the update call
    /// </summary>
    var me = this;
    try {
        if (me.visual.find("#lstTarget .vc-list-item.selected").length === 1 &&
            me.visual.find("#lstSource .vc-list-item.selected").length === 1) {
              me.visual.find("#btn-exchange").remove();
            me.visual.find("#divTarget")
                .after("<div id='btn-exchange' style='margin-left:10px;'><i class='fa fa-retweet' style='font-size:2em'></i><br/>" + me.resources.swapReports+"</div>");
            me.visual.find("#btn-exchange").button().off("click").on("click", function () {  me.swapReportsClick(); });
        } else {
            me.visual.find("#btn-exchange").remove();
        }

    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.clickAddRemoveArrow', ex);

    }
    return true;
};

MSAssignmentReport2Logger.prototype.swapReportsClick = function()  {
    /// <summary>
    /// This function calls the webservice for the swapping of the reports 
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) { return false; }
        
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({ 'type': 3, 'id': me.visual.find("#lstSource .vc-list-item.selected").data("id"), 'assID': me.assID, exchangeReportId: me.visual.find("#lstTarget .vc-list-item.selected").data("id") }),
            function (result) {
                try {
                    var addToTarget, addToTargetClone, addToSource, addToSourceClone;
                    if (result !== true) {

                        me.showMessage(me.resources.err_saveData, true);

                        return false;
                    } else {

                        addToTarget  = me.visual.find("#lstSource .vc-list-item.selected");
                        addToTargetClone = addToTarget.clone();
                        addToTarget.remove();
                        addToSource = me.visual.find("#lstTarget .vc-list-item.selected");
                        addToSource.remove();
                        addToSourceClone = addToSource.clone();

                        addToTargetClone.removeClass("selected icon-color-error icon-color-ok");

                        addToSourceClone.removeClass("selected icon-color-ok icon-color-error");
                        me.visual.find("#lstSource").append(addToSourceClone);
                        me.visual.find("#lstTarget").append(addToTargetClone);
                        me.visual.find("#btn-exchange").remove();

                    }
                    if (me.VCMQ_update_message.length > 0) {
                        window._VCMQ.produce(me.visual, me.vcgid, me.VCMQ_update_message, '');
                    }

                    return true;
                } catch (ex1) {
                    me.writeError('MSAssignmentReport2Logger.addAssignmentmentItemSpecificsResult', ex1);
                    return false;
                }
            });

        return sTmp;
    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};
MSAssignmentReport2Logger.prototype.addAssignmentItemSpecifics = function (row) {
    /// <summary>
    /// This function inits the assigment specific icons if implemented
    /// </summary>
    ///<param name='row'> a row object to add the item </param>
    var me = this;
    var sTmp = "";
    try {
        if (me.error) { return false; }
        sTmp += "<div class='report-exchange-add' data-id='"+row.id+"' title='"+ me.resources.add +"'><i class='fa fa-arrow-alt-circle-right'></i></div>";
        sTmp += "<div class='report-exchange-remove' data-id='" + row.id +"' title='"+me.resources.remove +"'><i class='fa fa-arrow-alt-circle-left'></i></div>";  
        return sTmp;
    } catch (ex) {
        me.writeError('MSAssignmentReport2Logger.addAssignmentmentItemSpecifics', ex);
        return false;
    }
};


